<template>

  <v-app>
    <v-content>
      <v-container>
        <v-row cols="10">
          <v-style type="text/css" rel="stylesheet">{{ this.$store.getters.getCSS }}</v-style>
          <v-col>
            <Challenge
              :title="title"
              :labid="labid"
            >
            </Challenge>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>

</template>

<script>

import Challenge from '@/components/Challenge.vue';

export default {
  name: "App",
  components: {
    Challenge
  },
  data() {
    return {
      title: null,
      labid: null,
      questions: null,
      images: null
    };
  },
  created() {
    this.getChallengeDetails();
  },
  methods: {
    getChallengeDetails() {

      /* eslint-disable no-console */

      this.$axios
      .get("/lab-details")
        .then(response => {
          console.log(response.data);

          if ("title" in response.data) {

            this.title = response.data["title"];
            this.labid = response.data["labid"];

            // alert(JSON.stringify(response.data["questions"], 0, 4));
            // alert(response.data["questions"].length);

            this.$store.dispatch("saveAllImages", response.data["images"]);
            this.$store.dispatch("setCSS", response.data["style"]);
            this.$store.dispatch("setChallengeDescription", response.data["desc"]);

            let questions = response.data["questions"];
            let index = -1;

            this.questions = new Array(questions.length);

            for (var question in questions) {
              index = questions[question]["qid"] - 1;

              this.questions[index] = {
                "question": questions[question]["ques"],
                "task": questions[question]["task"],
                "hints": questions[question]["hints"]
              }
            }
            // console.log(this.questions);
            this.$store.dispatch("setQuestionsList", this.questions);
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(function() {
          //console.log("Finally!");
        });

      /* eslint-enable no-console */

    }
  }
};
</script>